import { io, Socket } from "socket.io-client";

const socket: Socket = io(process.env.REACT_APP_BASE_URL || "", {
  autoConnect: false, // so you can connect when needed
});

const connectSocket = () => {
  if (!socket.connected) {
    socket.connect();
  }
};

const disconnectSocket = () => {
  if (socket.connected) {
    socket.disconnect();
  }
};

const onLocationUpdate = (
  callback: (data: { latitude: number; longitude: number }) => void,
) => {
  socket.on("locationUpdate", callback);
};

const offLocationUpdate = () => {
  socket.off("locationUpdate");
};

const emitTest = (payload: any) => {
  socket.emit("userMoved", payload);
};

export {
  socket,
  connectSocket,
  disconnectSocket,
  onLocationUpdate,
  offLocationUpdate,
  emitTest,
};
